import React from 'react';

interface CreateAdvisorCardProps {
  onClick: () => void;
}

const CreateAdvisorCard: React.FC<CreateAdvisorCardProps> = ({ onClick }) => {
  return (
    <div 
      className="border border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center text-center hover:bg-gray-50 cursor-pointer transition-colors"
      onClick={onClick}
    >
      <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
        <svg className="w-8 h-8 text-amber-800" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-800 mb-2">Create Advisor</h3>
      <p className="text-gray-600 text-sm">Author your own custom advisor</p>
    </div>
  );
};

export default CreateAdvisorCard;